import { createContext } from 'react';
import lightTheme from "../theme/themes/light.js";
const ThemeContext = /*#__PURE__*/createContext(lightTheme);
export default ThemeContext;